<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();
  
async function updateSetting(value: boolean) {
  await settingsStore.set('showNonStandardUnitHourRegistrations', value);
}
</script>
  
<template>
  <SettingsToggle
    :checked="settingsStore.settings.showNonStandardUnitHourRegistrations"
    :label="t('hourRegistration.showNonStandardUnitHourRegistrations')"
    :description="t('hourRegistration.showNonStandardUnitHourRegistrationsDescription')"
    @change="updateSetting"
  />
</template>